module.exports = __webpack_public_path__ + "img/active_bg.8856f6e7.png";